export const TG_USERNAME = "Barsa21win"; 
export const TG_BASE_URL = `https://t.me/${TG_USERNAME}`;